import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pplus-list-table',
  templateUrl: './pplus-list-table.component.html',
  styleUrls: ['./pplus-list-table.component.scss']
})
export class PplusListTableComponent implements OnInit {

  @Input() headers;
  @Input() data;
  @Input() comparableData;
  @Input() comparable = false;
  @Input() totalRow;
  @Input() comparableTotalRow;

  constructor() { }

  ngOnInit() {
  }

}
